import { useForm } from 'react-hook-form';
import { useBoatDetails } from 'components/pdp/v3/hooks';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { useUpdateBoatMutation } from '../blw/hooks';

const MultiBookToggle = ({ boatId }) => {
  const {
    boatDetails: { multibook_enabled },
  } = useBoatDetails(boatId);

  const updateBoatMutation = useUpdateBoatMutation();

  const toggleBoatMultiBook = async () => {
    const multibookEnabled = watch('multibook_enabled');
    await updateBoatMutation.mutateAsync({
      boatId,
      body: {
        multibook_enabled: multibookEnabled,
      },
    });
  };

  const methods = useForm({
    mode: 'onChange',
  });

  const { register, watch } = methods;

  return (
    <div className="u-flex u-flexAlignItemsCenter u-sm-flexCol u-sm-flexAlignItemsStart ">
      <div className="u-flex u-flexAlignItemsCenter u-mr2 u-sm-mb1">
        <h3 className="u-mb0 u-textBold u-sm-fsXs u-fsLgM u-inlineBlock">Enable two 4-hour trips</h3>
        <Tooltip
          place="top"
          trigger="mouseenter"
          hideOnScroll
          triggerWith={
            <svg fill="#0e7873" height={16} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
              <path d="M504 980.2C239.9 980.2 27.8 768.1 27.8 504S239.9 27.8 504 27.8 980.2 239.9 980.2 504 768.1 980.2 504 980.2zm0-887.4C274.6 92.8 92.8 274.6 92.8 504S274.6 915.2 504 915.2 915.2 733.4 915.2 504 733.4 92.8 504 92.8zm34.6 467.5v30.3c0 17.3-13 34.6-34.6 34.6s-34.6-13-34.6-34.6v-51.9c0-13 4.3-21.6 13-26h4.3l34.6-17.3h8.7c4.3 0 8.7-4.3 8.7-4.3 43.3-17.3 56.3-34.6 56.3-73.6 0-51.9-43.3-90.9-95.2-90.9-43.3 0-82.2 30.3-95.2 69.3 0 8.7-17.3 21.6-34.6 17.3-17.3-8.7-26-26-21.6-43.3C365.7 300.6 430.6 253 504.2 253c90.9 0 160.2 69.3 160.2 155.8 0 69.3-30.3 108.2-95.2 134.2-4.3 0-8.7 4.3-13 4.3h-8.6c-4.6 8.6-9 8.6-9 13zM504 755.1c-21.6 0-39-17.3-39-39s17.3-39 39-39 39 17.3 39 39-17.4 39-39 39z" />
            </svg>
          }
        >
          <div style={{ maxWidth: '160px' }}>
            <div className="u-textGrayMedium u-textLeft u-sm-fsXxs u-fsSm">
              Enable two 4-hour trips per day to get more money out of your boat. Your boat will remain in the search
              results for a given day if a 4-hour trip is booked so another 4-hour trip can be booked.
            </div>
          </div>
        </Tooltip>
      </div>
      <label className="switch switch-left-right tooltipstered u-inlineBlock" id="switch">
        <input
          name="multibook_enabled"
          ref={register}
          defaultChecked={multibook_enabled}
          className="switch-input"
          id="toggle_on_site_checkbox"
          type="checkbox"
          onChange={() => toggleBoatMultiBook()}
        />
        <span className="switch-label" data-off="Disabled" data-on="Enabled" />
        <span className="switch-handle" />
      </label>
    </div>
  );
};

export default MultiBookToggle;
